import './Styles/fonts.css';
import './Styles/variables.css';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Auth0Provider } from '@auth0/auth0-react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { datadogLogs } from '@datadog/browser-logs';
import { router } from './router';
import { Res } from './resources';
import { theme } from './Styles/theme';

datadogLogs.init({
  clientToken: Res.api.datadog.CLIENT_TOKEN,
  site: 'datadoghq.eu',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  env: Res.env,
  service: 'platform-frontend',
  forwardConsoleLogs: 'all',
  silentMultipleInit: true,
  beforeSend: (log) => {
    if (log.http && log.http.url.includes('mapbox')) {
      //abort
      return false;
    }
    return true;
  },
});

// Logs a message to Datadog to indicate a new navigation started, logging a few user information, so we can track the user journey and the platform usage
datadogLogs.logger.info('Navigation started');

const queryClient = new QueryClient();

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <Auth0Provider
          domain={Res.api.auth0.DOMAIN}
          clientId={Res.api.auth0.CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: Res.api.auth0.AUDIENCE,
          }}
          cacheLocation="localstorage"
        >
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} />
          </ThemeProvider>
        </Auth0Provider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
